import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timer } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { AppFacadeService } from '@services/app-facade.service';
import { UserModel } from '@models/user.model';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })

export class VersionCheckService {
    // this will be replaced by actual hash post-build.js
    private currentVersion = '{{POST_BUILD_ENTERS_VERSION_HERE}}';
    loggedUser: UserModel;
    alertParams = {
        background: '#ffffff',
        position: 'top-end',
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: 'Update App',
        width: '400px'
    }
    
    constructor(private http: HttpClient, private appFacadeService: AppFacadeService,) {
        this.appFacadeService.getLoggedUser$().subscribe(user => {
            this.loggedUser = user;
        })
     }
    
    /**
    * Checks in every set frequency the version of frontend application
    * @param url
    */
    public initVersionCheck() {
        const url = `${window.location.protocol}//${window.location.hostname}:${window.location.port || 443}/version.json`
        // this.launchMessageAlert('mandatory')
        setInterval(() => {          
            //this.checkVersion(url);
        }, 1000 * 60);
    }
    /**
    * Will do the call and check if the hash has changed or not
    * @param url
    */
    private checkVersion(url) {
        this.http.get(url)
        .subscribe((response: any) => {
            const deployedVersion = response.version;
            const typeReload = response.type
            if (deployedVersion > this.currentVersion) {
                this.launchMessageAlert(typeReload)
            }
            this.currentVersion = deployedVersion;
        },
        (err) => {
            console.error(err, 'Could not get version');
        });
    }

    launchMessageAlert(type) {
        const modalTime = type === 'critical' ? 5000 : type === 'mandatory' ? 1000 * 120 : 0
        let messageText = this.messageTextAlert(type)
        
        let params = Swal.mixin({
            html: `${messageText.replace('{time}', type === 'mandatory' ? '2:00 minutes' : '5')}`,
            backdrop: type === 'optional' || type === 'mandatory' ? false : true,
            timer: type === 'mandatory' ? modalTime - 10000 : modalTime,
            willClose: () => {
                type === 'mandatory'
                    ? ( messageText = this.messageTextAlert('critical'),
                        this.fireSweetAlert(params = params.mixin({
                            backdrop: true,
                            timer: 10000,
                            willClose: () => { window.location.reload() }
                        }))
                      )
                    : window.location.reload()
            }
        })
        this.fireSweetAlert(params)

        if(type === 'mandatory' || type === 'critical')
            timer(1000, 1000).pipe(
                take(modalTime/1000 + 1),
                map(i => i + 1),
                map(i => (modalTime/1000) - i)
            ).subscribe(count => {
                let stringTime = `${count.toString()} seconds`
                if(type === 'mandatory') {
                    const minutes = Math.trunc(count / 60)
                    const seconds = count % 60
                    stringTime = `${minutes > 0 ? minutes+':' : ''}${count % 60 < 10 ? '0'+seconds : seconds} ${minutes > 0 ? 'minutes' : 'seconds'}`
                }
                document.getElementById('countTime').innerHTML = stringTime
            })
    }

    fireSweetAlert(params) {
        params.fire(this.alertParams).then(result => {
            if (result.value) {
                window.location.reload();
                params.close()
            }
        })
    }

    messageTextAlert(type) {
        return `<b>Hi ${this.loggedUser.firstName}</b><img src="./assets/images/hand.png" width="30px"></img> ${type === 'optional'
            ? 'There is an app update available. Please save any changes currently in progress and then click the "Update App" button below.'
            : `An important app update is available. The app will update automatically in <b id="countTime">{time}</b>${type === 'mandatory'
                ? '. To avoid losing changes youre making, please save/submit anything currently in progress'
                : ''
            }.`
        }`
    }

}
